import type { Underlying } from 'models/underlying';

export function fullTextSearch(underlyings: Underlying[], text: string): Underlying[] {
  return underlyings.filter(
    underlying => JSON.stringify(underlying).toLocaleLowerCase().indexOf(text.toLocaleLowerCase()) >= 0,
  );
}
